import { API_BASE_URL } from '../library/globals';
import { GET } from './api-hander.service';
import { GET_PICKUP_RULES } from './api.constants';

// HLD ISS-287978 D-portal-1 (option 1): reuse the pickup-slots read, scoped to appointment
// rows. projectx must honor `slotType` and return taskType/tags/serviceTime on each rule.
export const getAppointmentSlots = async () => {
    return GET(`${API_BASE_URL}${GET_PICKUP_RULES}`, { slotType: 'appointment' });
};
